// 上海舱单(不知道业务逻辑，先把对应的axios留着，接口调通之后再删除axios4,axios5)
import { request } from "@/utils/request.js";
import { axiosHeadEnum } from "./enum";

const FEST_URL = axiosHeadEnum[process.env.VUE_APP_API_ENV];

/**
 * 账号配置模块--start
 */

// 用户列表
export function userManageList(param) {
    return request("/user/list", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 用户新增
export function userManageAdd(param) {
    return request("/user/save", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 用户编辑
export function userManageEdit(param) {
    return request("/user/update", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 用户删除
export function userManageDel(param) {
    return request("/user/delete", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 设置默认
export function userManageDefault(param) {
    return request("/user/setDef", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 获取token
export function userManageGetToken(param) {
    return request("/user/getToken", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 测试状态
export function userManageTestStatus(param) {
    return request("/user/tokenTest", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 账号配置模块--end
 */

/**
 * 模板制作模块--start
 */

// 请求列表信息
export function getTemplateList(param) {
    return request("/template/list", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//删除模板
export function deleteTemplate(id) {
    return request(`/template/delete`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 下载文件
export function downloadTemplate(id) {
    return request("/template/download", "get", id, {
        responseType: "blob",
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// Excel识别成模板
export function AIRecognize(data) {
    return request("/template/saveTask", "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//查询国家列表
export function getCountryList() {
    return request(`/template/country`, "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//查询港口列表
export function getPortList() {
    return request(`/template/port`, "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 第一次识别
export function firstMerger(param) {
    return request("/template/firstMerger", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//获取模板详情
export function assistantTemplateDetail(id) {
    return request(
        `/template/detail`,
        "get",
        {
            id,
        },
        {
            baseURL: FEST_URL,
            timeout: 600000,
        },
    );
}

// 修改初次合并后的json
export function updateFirstMergeJson(param) {
    return request(
        "/template/updateFirstMergerJson",
        "post",
        param,
        {
            baseURL: FEST_URL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 600000,
        },
        true,
    );
}

// 拿到excel的sheetsName
export function getExcelSheetsName(param) {
    return request("/template/getExcelSheets", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 校验模板数据
export function checkTemplateData(param) {
    return request("/template/checkTemplateData", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 直接发送做单平台平台
export function sendMergeJsonToZD(param) {
    return request("/template/directlyImport", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 品名转换-新
export function ywGnameConverNew(param) {
    return request("/template/cargoTransition", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 检查品牌是否存在
export function checkBrandExists(param) {
    return request("/template/brand/exists", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 图片识别HScode
export function getHsCodeByImg(param) {
    return request("/template/getGoodsHsCodeByPic", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 获取敏感词
export function getSensitiveWord(param) {
    return request("/template/sensitiveWords", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 获取HS新
export function getCodeTsByGnameAndMaterialNew(param) {
    return request("/template/getHsCode", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 品名标准化(旧)
export function delDescrition(param) {
    return request("/template/delCargoNameDescriptive", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}
// 品名标准化(新)
export function delDescritionNew(param) {
    return request("/template/getGoodsHsCode", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 报关单文件导入
export function importByCustomFile(param) {
    return request("/customs-template/uploadFile", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 文件导入(做单平台模板文件)
export function importByZDTemplateFile(param) {
    return request("/template/uploadFileByTemplate", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 报关单文件生成
export function customFileCreate(param) {
    return request("/customs-template/createBill", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 保存报关单文件
export function saveCustomFile(param) {
    return request("/customs-template/saveBill", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 识别文件数据
export function analysisFile(param) {
    return request("/template/uploadFile", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 文件上传
export function uploadAssistantFile(param) {
    return request("/file/file/upload", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 清单识别后台导入：提交后由服务端异步处理。
 * 若后端路径与此前约定不一致，请只改此处 URL 与入参字段名。
 * @param {FormData} param
 * @param {Object} param.goodsIndex 商品坐标信息
 * @param {String} param.sheetName 工作表名称
 * @param {String} param.fileUrl 文件URL
 * @param {String} param.orderNoSuffix 自编号
 */
export function recognizeListBackgroundSubmit(param) {
    return request("/template/uploadBack", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 清单识别导入:文件流
 * @param {*} param
 * @param {File} param.file 文件
 * @param {String} param.sheetName 工作表名称
 * @param {String} param.goodsIndex 商品坐标信息
 * @param {String} param.orderNoSuffix 自编号
 * @returns
 */
export function recognizeListBackgroundSubmitByFile(param) {
    const goodsIndex =
        typeof param.goodsIndex === "string"
            ? param.goodsIndex
            : JSON.stringify(param.goodsIndex || {});
    return request(
        "/template/uploadBackByFile",
        "post",
        {
            file: param.file,
            sheetName: param.sheetName,
            goodsIndex,
            orderNoSuffix: param.orderNoSuffix,
        },
        {
            baseURL: FEST_URL,
            timeout: 600000,
        },
        true,
    );
}

// 识别品名数据
export function analysisGname(param) {
    return request("/template/getTemplateGoods", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 更新模板数据（基础+品名）
export function updateTemplateDataBaseAndGoods(param) {
    return request("/template/updateTemplate", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//获取模板数据详情
export function getTemplateDataDetail(param) {
    return request("/template/getTemplate", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 根据hs进行查询-获取hsCode
export function getHsCodeSelect(param) {
    return request("/template/getHsCodeSimple", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//获取hsCode要素内容
export function getElementContent(param) {
    return request("/template/getElementContent", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 根据品名+材质查询HS简表（联想用）
export function getHsCodeSimpleByName(param) {
    return request("/template/getHsCodeSimpleByName", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 市场采购号(联想用)
export function getMarketPurchaseCodeSimpleByName(param) {
    return request(
        "/template/getMerchantInfoList",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

// 根据hsCode+品名获取HS完整数据
export function getHsDataByHsCode(param) {
    return request("/template/getHsDataByHsCode", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 获取可能的HS编码
 * @param {*} param  {"cargoName": "","material": "","otherFactors": {},"pic": "","usage": ""}
 * @returns
 */
export function matchPossibleHsCodes(param) {
    return request("/template/matchPossibleHsCodes", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
        // 成功标识为 status:200，非 code:200
        onlyJudgeStatus: true,
    });
}

// 文件导入(基础报关数据)
export function getDataByExcelTemplate(param) {
    return request("/template/getTemplateBaseInfoByFile", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 文本导入(基础报关数据)
export function getDataByTextTemplate(param) {
    return request(
        "/template/getTemplateBaseInfoByTxt",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * 模板制作模块--end
 */

/**
 *
 * 智能制单模块--start
 */

/**
 * @description 智能制单导出
 */
export function headExport(param) {
    return request("/assistant/head/export", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 原始数据新增
export function originGoodsAdd(param) {
    return request("/head/originGoodsAdd", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 归类数据新增
export function assortGoodsAdd(param) {
    return request("/head/assortGoodsAdd", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 归类数据删除
export function deleteAssortGoods(param) {
    return request("/head/assortGoodsDel", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 重新导入
export function reImportOrder(param){
    return request("/head/importBill","post",param,{
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 同步做单平台数据
export function syncZDData(param) {
    return request(
        "/template/refreshHead",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * @description: 更新原始数据hscode
 * @param {Number} id
 * @param {Number} goodsId
 * @param {String} hscode
 * @param {String} unit2
 * @param {String} unit1
 * @returns
 */

export function updateOriHsCodeInfo(param) {
    return request("/head/updateHsCode", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

export function zjHsCodeQuery(param) {
    return request("/head/zjHsCodeQuery", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//从做单平台平台拉取新数据
export function updateOrderFromZD(id) {
    return request(`/head/updateOrderFromZD`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// hscode查询
export function hsCodeQuery(param) {
    return request("/head/hsCodeQuery", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 品名查询
export function gNameListQuery(param) {
    return request("/sycnConfig/queryHsCodeByName", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 查敏感词
export function warningWordQuery(param) {
    return request("/goodDict/getRules", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 原始修改要素
export function gModelInfoUpdate(param) {
    return request(
        "/sycnConfig/updateChangeElement",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

// 修改表体(未归类)
export function bodyUpdateWithNoClassify(param) {
    return request(
        "/sycnConfig/updateOriginEdit",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

// 修改表体(已归类)
export function bodyUpdateWithClassify(param) {
    return request(
        "/sycnConfig/updateAssortEdit",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * 保存归类数据(表头+表体)
 * @param {Object} billHead
 * @param {Object} billHead2
 * @param {Object} ywAssortGoods // 归类表体数据
 * @param {Object} ywMarketInfo
 *  */
export function saveAssortData(param) {
    return request("/head/saveBill", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 保存数据，表体（归类数据)
 * @param {Object} billHead
 * @param {Object} billHead2
 * @param {Object} ywAssortGoods // 归类表体数据
 * @param {Object} ywMarketInfo
 *  */
export function saveGoodsData(param) {
    return request("/head/saveBillGoods", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 原始修改品名
export function gNameUpdateOrigin(param) {
    return request("/sycnConfig/updateDetailOrigin", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 简化
export function simplefiyBodyData(param) {
    return request("/template/reducePreview", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 撤销简化
export function unReducePreview(param) {
    return request("/template/unReducePreview", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改表体(简化)
export function bodyUpdateWithSimpleify(param) {
    return request(
        "/sycnConfig/updateReducetEdit",
        "post",
        param,
        {
            baseURL: FEST_URL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 600000,
        },
        true,
    );
}

//删除智能制单数据
export function deleteHead(id) {
    return request(`/head/delete`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//和做单平台进行数据同步
export function syncData(data) {
    return request(
        `/head/syncOrderData`,
        "post",
        data,
        {
            baseURL: FEST_URL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 600000,
        },
        true,
    );
}

//修改表头
export function updateHead(data) {
    return request(`/head/update`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}
/**
 * 智能归类
 * @param {Number} id
 */
export const smartAssortFunc = (data) => {
    return request(
        `/template/detailAssort`,
        "post",
        data,
        {
            baseURL: FEST_URL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 600000,
        },
        true,
    );
};

// 请求列表信息
export function getHeadList(param) {
    return request("/head/list", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 查询单价，重量范围
 * @param {*} param [{hscode: string, name: string}]
 * @returns
 */
export function getPriceAndWeightRange(param) {
    return request("/head/getPriceWeight", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//获取详情
export function getHeadDetail(param) {
    return request(`/head/detail`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//整单逻辑校验
export function orderCheck(id) {
    return request(`/head/orderCheck`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 导出回单
export function exportBackOrder(headId) {
    return request("/head/exportBill", "get", headId, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//修改商品信息
export function updateGood(data) {
    return request(`/goods/update`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//删除商品
export function deleteGood(id) {
    return request(`/goods/delete`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 按KG成交
 * @param {Number} headId
 * @returns
 */
export function dealByKg(data) {
    return request("/template/dealByKg", "get", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//数据清单标准化
export function normalizeDataList(id) {
    return request(`/head/normalizeDataList`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//发送做单平台平台
export function sendZDPlatform(id) {
    return request(`/head/sendZDPlatform`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 云编号获取草单报关单
export function getCustomDataByUniqueNo(param) {
    return request("/customs-template/getBillByCloudNumber", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 获取文件上传预签名 URL
export function getFileUploadPresignedUrl(param) {
    return request(
        "/file/getUploadUrl",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
        },
        true,
    );
}

// 批量上传PDF模板文件
// [{ pdfUrl: string, billSeq: string, billNo?: string }]
export function uploadPdfBatch(param) {
    return request("/customs-template/uploadPdfBatch", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 智能制单模块--end
 */

/**
 * 校验订单模块
 */

// 订单列表
export function checkOrderList(param) {
    return request("/verification/list", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 批量上传（ids: number[]）
export function batchUploadOrderList(param) {
    return request(
        "/customs-template/createBillBatch",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
        },
    );
}

// 订单导入
export function checkOrderImport(param) {
    return request(
        "/verification/import",
        "post",
        param,
        {
            baseURL: FEST_URL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 600000,
        },
        true,
    );
}

// 订单删除
export function checkOrderDel(param) {
    return request(
        "/verification/delete",
        "post",
        param,
        {
            baseURL: FEST_URL,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            timeout: 600000,
        },
        true,
    );
}

//订单校验
export function checkOrderVerification(param) {
    return request(
        "/verification/verification",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

// 获取表体
export function getCheckOrderBodyData(param) {
    return request(
        "/verification/getBody",
        "post",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
        true,
    );
}

/**
 * 常用配置模块
 */

/**
 * 市场采购号列表
 */
export function getMarketPurchaseCodeList() {
    return request("/my-setting/getMarketPurchaseCodeList", "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 修改市场采购号
 */
export function updateMarketPurchaseCode(data) {
    return request("/my-setting/saveMarketPurchaseCode", "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 关联配置列表
 */
export function connectConfigList() {
    return request("/my-setting/getCompanyRelationList", "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}
// 关联配置设置
export function connectConfigSave(param) {
    return request("/my-setting/saveCompanyRelation", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}
// 设置默认
export function connectConfigDefault(param) {
    return request("/my-setting/setDefCompanyRelation", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 删除关联配置
export function deleteConnectConfig(param) {
    return request("/my-setting/deleteCompanyRelation", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 自定义配置保存
export function selfConfigSettingSave(param) {
    return request("/my-setting/saveMyCustomsSetting", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 自定义配置查询
export function getSelfConfigSetting() {
    return request("/my-setting/getMyCustomsSetting", "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 参数配置模块
 */

/**
 * 报关参数
 */
// 查询报关参数
export function customsParamDetail() {
    return request("/zj-config/customsSetting", "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 同步报关配置
export function syncCustomsConfig() {
    return request("/sycnConfig/loadParamConfig", "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// // 保存报关参数
// export function saveCustomsDict(data) {
//     return request(`/customsParamDict/save`, "post", data, {
//         baseURL: FEST_URL,
//     });
// }

// // 修改报关参数
// export function updateCustomsDict(data) {
//     return request(`/customsParamDict/update`, "post", data, {
//         baseURL: FEST_URL,
//     });
// }

// 修改报关参数
export function updateCustomsDictNew(data) {
    return request(`/zj-config/saveCustomsSetting`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 申报单位增改查
 */

// 请求申报单位列表
export function getAgentList(param) {
    return request(`/zj-config/getAgentList`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增申报单位
export function addAgent(param) {
    return request("/ywCustomsCompanyInfo/intertAgentInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改申报单位
export function editAgent(param) {
    return request("/ywCustomsCompanyInfo/updateAgentInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 同步申报单位
export function syncAgent(param) {
    return request("sycnConfig/loadAgentInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 收发货人增改查
 */

// 请求收发货人列表
export function getConsigneeList(param) {
    return request(`/zj-config/getOwnerList`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增收发货人
export function addConsignee(param) {
    return request("/ywCustomsCompanyInfo/intertOwnerInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改收发货人
export function editConsignee(param) {
    return request("/ywCustomsCompanyInfo/updateOwnerInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//同步收发货人
export function syncConsignee(param) {
    return request("/sycnConfig/loadOwnerInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 生产销售单位增改查
 */

// 请求生产销售单位列表
export function getMerchantList(param) {
    return request(`/zj-config/getProducerList`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增生产销售单位
export function addMerchant(param) {
    return request("/ywCustomsCompanyInfo/intertProducerInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改生产销售单位
export function editMerchant(param) {
    return request("/ywCustomsCompanyInfo/updateProducerInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//同步生产销售单位
export function syncMerchant(param) {
    return request("/sycnConfig/loadProducerInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 护照
 */

// 请求护照列表
export function getPassportList(param) {
    return request(`/zj-config/getPassportList`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增护照
export function addPassport(param) {
    return request("/ywCustomsPassport/intertYwCustomsPassport", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改护照
export function editPassport(param) {
    return request("/ywCustomsPassport/updateYwCustomsPassport", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//同步护照
export function syncPassport(param) {
    return request("/sycnConfig/loadPassportInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 供应商
 */

// 请求供应商列表
export function getSupplierList(param) {
    return request(`/zj-config/getTraderList`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增供应商
export function addSupplier(param) {
    return request("/ywCustomsTrader/intertYwCustomsTrader", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改供应商
export function editSupplier(param) {
    return request("/ywCustomsTrader/updateYwCustomsTrader", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//同步供应商
export function syncSupplier(param) {
    return request("/sycnConfig/loadTraderInfo", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 自定义商品数据
 */

// 自定义商品列表
export function getCustomsGoodsList(param) {
    return request(`/zj-config/loadDetailData`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 同步商品列表
export function sysCustomsGoodsList(param) {
    return request(`/sycnConfig/loadDetailData`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 货代货组人
 */

// 请求货代货组人列表
export function getShipAgentList(param) {
    return request(`/zj-config/getFrightList`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增货代货组人
export function addShipAgent(param) {
    return request("/ywCustomsOfFright/intertCustomsOfFright", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改货代货组人
export function editShipAgent(param) {
    return request("/ywCustomsOfFright/updateCustomsOfFright", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//同步货代货组人
export function syncShipAgent(param) {
    return request("/sycnConfig/getListOfFright", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 *  商品字典模块
 */

/**
 *
 *  敏感规则
 */

// 获取海关列表
export function getCustomsList() {
    return request(`/goodDict/customs/list`, "get", "", {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 保存海关列表
export function saveCustoms(data) {
    return request(`/goodDict/customs/save`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 删除海关数据
export function deleteCustoms(id) {
    return request(`/goodDict/customs/delete`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

//开启、禁用海关模块
export function disableCustoms(data) {
    return request(`/goodDict/customs/disable`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 同步海关规则
export function syncCustomsRule(param) {
    return request("/goodDict/customs/syncRule", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 *  商品敏感词具体规则
 */
// 新增商品规则
export function addGoodDictPackage(data) {
    return request(`/goodDict/rule/save`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 删除商品规则
export function deleteGoodDictPackage(id) {
    return request(`/goodDict/rule/delete`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}
// 更新商品规则
export function updateGoodDictPackage(data) {
    return request(`/goodDict/rule/update`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 获取商品规则列表
export function getGoodDictPackageList(param) {
    return request(`/goodDict/rule/package`, "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 名称替换
 */

// 名称替换列表
export function getGoodDictList(customsId) {
    return request(`/goodDict/list`, "get", customsId, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 新增名称替换
export function saveGoodDict(data) {
    return request(`/goodDict/save`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 修改名称替换
export function updateGoodDict(data) {
    return request(`/goodDict/update`, "post", data, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

// 删除名称替换
export function deleteGoodDict(id) {
    return request(`/goodDict/delete`, "get", id, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 名称转编码
 * @param {String} cargoName 商品名称
 * @param {String} hsCode 商品编码
 * @param {String} controlMark 监管证件
 * @param {String} expTaxBack 退税
 * @param {String} element 要素
 * @param {String} noteS 解释
 */
export function addGNameToCodeTs(param) {
    return request("/setting/hsCode/create", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 品名对应hsCode分页
 * @param {String} cargoName 商品名称
 * @param {Number} pageNo 页码
 * @param {Number} pageSize 每页条数
 */
export function getGNameToCodeTsList(param) {
    return request("/setting/hsCode/page", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 更新品名对应编码
 * @param {String} cargoName 商品名称
 * @param {String} hsCode 商品编码
 * @param {String} controlMark 监管证件
 * @param {String} expTaxBack 退税
 * @param {String} element 要素
 * @param {String} noteS 解释
 * @param {Number} id
 */
export function updateGNameToCodeTs(param) {
    return request("/setting/hsCode/update", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 查询hs库
 * @param {String} hsCode 商品编码
 */

export function getHsCodeInfo(param) {
    return request("/setting/hsCode/library", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 查询HS对应的单位
 * @param {String} hsCode 商品编码
 */
export function getHsCodeDetailInfo(hscode) {
    return request(
        `/INPUT/GetHSCodeList?HSCode=${hscode}`,
        "get",
        {},
        {
            baseURL: "https://jd-api.nbhuojian.com",
            timeout: 600000,
        },
    );
}

/**
 * @description 删除品名对应编码
 * @param {Number} id
 */
export function deleteGNameToCodeTs(id) {
    return request(
        "/setting/hsCode/delete",
        "delete",
        id,
        {
            baseURL: FEST_URL,
            timeout: 600000,
        },
        false,
        true,
    );
}

/**
 * 校验关区-截关期模块
 */

/**
 * @description 根据船名航次获取关区信息
 * @param {String} vesselName 舱名
 * @param {String} voyage 舱次
 * @returns
 */
export function getPortInfoByVessels(param) {
    return request("/zj-config/getPortInfoByVessels", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 根据船名航次获取上海船期相关信息
 * @param {String} vesselName 船名
 * @param {String} voyage 航次
 */
export function getShVesselsInfo(param) {
    return request("/zj-config/getShVessels", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 根据船名航次获取宁波船期相关信息
 * @param {String} vesselName 船名
 * @param {String} voyage 航次
 */
export function getNbVesselsInfo(param) {
    return request("/zj-config/getNbVessels", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 根据离境口岸获取出口口岸信息
 * @param {String} depPortCode 离境口岸
 */
export function getExitPortByDepPort(param) {
    return request("/zj-config/getExitPortByDepPort", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @param {File} file 文件
 * @param {String} txt
 * @param {*} param
 * @returns
 */
export function easyImport(param) {
    return request("/template/uploadEasy", "post", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 获取商品SSE
 * @param {String} json JSON数据
 * @returns
 */
export function getTemplateGoodsSse(param) {
    return request("/template/getTemplateGoodsSse", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * 统计板块
 */

/**
 * @description 收发货人金额统计
 * @param {Object} key 抬头
 */
export function getConsigneeAmountStatistic(param) {
    return request("/account/getAmountCollect", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 单个收发货人金额统计
 * @param {Number} pageNo
 * @param {Number} pageSize
 * @param {String} code
 */
export function getCompanyAmountPage(param) {
    return request("account/getCompanyAmountPage", "get", param, {
        baseURL: FEST_URL,
        timeout: 600000,
    });
}

/**
 * @description 市场采购号金额统计
 * @param {Object} param
 * @param {String} param.key 市场采购号
 * @param {String} param.startTime 开始时间
 * @param {String} param.endTime 结束时间
 */
export function getMarketPurchaseAmountStatistic(param) {
    return request(
        "/account/getAmountCollectByMarketPurchaseCode",
        "get",
        param,
        {
            baseURL: FEST_URL,
            timeout: 600000,
        },
    );
}
